import { createRequestReducer } from '@td/utils';
import { PROVIDER_SURGE_INCENTIVE_EDIT_REQUEST } from '../action-types';

export default createRequestReducer(PROVIDER_SURGE_INCENTIVE_EDIT_REQUEST);
